import React from 'react'

import type { CategoryBrandingContentBlock } from '@library/api-menu-experience'
import { CategoryBrandingHeader } from '@library/menu-page'

type CategoryBrandingContentBlockWrapperProps = {
  contentBlock: CategoryBrandingContentBlock
}

export const CategoryBrandingContentBlockWrapper = ({
  contentBlock,
}: CategoryBrandingContentBlockWrapperProps) => (
  <CategoryBrandingHeader contentBlock={contentBlock} />
)
